export default __webpack_public_path__ + "static/youngbroadway-36c47e9408b6f44ee6393164f99e469e.jpeg";